<template>
    <div class="content" ref="contentRef" id="contentRef" :style="{height:showHeight}">
      <van-swipe
        :style="{height:showHeight}"
        :autoplay="false"
        :loop="false"
        :show-indicators="false"
        :stop-propagation="false"
        :touchable="true"
        ref="swiper"
        :duration="0"
        @change="onChange"
      >
        <van-swipe-item
          v-for="item in contentList"
          :key="item.id"
        >
          <div class="content__icon">
            <div class="content__icon__wrapper left">
              <span
                class="iconfont content__icon__wrapper__item"
                @click="routeBack"
              >
              &#xe6a0;
              </span>
            </div>
            <div class="content__icon__wrapper left" @click="changeFontSizeSubtract">
              <span
                class="iconfont icon__subtract content__icon__wrapper__item"
              >
                &#xe629;
              </span>
            </div>
            <div id="add" class="content__icon__wrapper left" @click="changeFontSizeAdd">
              <span
                class="iconfont icon__add content__icon__wrapper__item"
              >
              &#xe681;
              </span>
            </div>
            <div class="content__icon__wrapper left" @click="backTop">
              <span
                class="iconfont icon__add content__icon__wrapper__item"
              >
              &#xe63d;
              </span>
            </div>
          </div>
          <div class="content__item">
            <div class="content__img" v-if="item.typeName === '图片'">
              <img
                :src="`${imgUrl}/${accessName}/${accessName}/${outfilePath}/${standardFile}`"
              />
              <p>{{picExplain}}</p>
            </div>
            <div class="content__text" v-else>
              <h4 class="content__text__h4" v-html="item.primersTitle"></h4>
              <h3 class="content__text__h3" v-html="item.title"></h3>
              <h4 class="content__text__h4" v-html="item.subtitle"></h4>
              <p class="content__text__p">
                <span>日期：{{item.pageDate}}</span>
                <span>【{{item.pageNum}}版：{{item.pageName}}】</span>
              </p>
              <p class="content__text__author" v-if="item.author">
                <span>【作者：{{item.author}}】</span>
              </p>
              <div
                class="content__text__img"
                v-for="(itemPictures, index) in item.attachedPictures"
                :key="index"
              >
                <img
                  :src="`${imgUrl}/${itemPictures.accessName}/${itemPictures.accessName}/${itemPictures.outfilePath}/${itemPictures.standardFile}`"
                />
                <p v-html="itemPictures.picExplain" class="left-align-text"></p>
              </div>
              <!-- <div
                  class="content__text__img"
                  v-for="(itemPictures, index) in attachedPictures"
                  :key="index"
              >
                  <img
                      :src="`${imgUrl}/${itemPictures.accessName}/${itemPictures.accessName}/${itemPictures.outfilePath}/${itemPictures.originalFile}`"
                  />
                  <div v-html="itemPictures.picExplain"></div>
              </div> -->

              <div :id="item.id" class="content__text__content" ref="text" v-html="item.content"></div>
            </div>
          </div>
          <Voice :voiceText="item.voiceText"/>
        </van-swipe-item>
      </van-swipe>
      <div class="content__left" @click="changePrev"></div>
      <div class="content__next" @click="changeNext"></div>
    </div>
    <Daily
      :newspaper="newspaper"
      :newspaperId="newspaperId"
      @emit-home="getDailyPageList"
      @getContentDirectory="getContentDirectory"
    />
    <!-- <Periodical v-else :newspaper="newspaper" :newspaperId="newspaperId" @emit-content="getDailyPageList" /> -->
</template>

<script>
import Daily from '../components/Daily'
import Voice from './Voice'
import { ref, watch, onMounted, computed, onBeforeUpdate } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { get } from '../../utils/request'
import Hammer from 'hammerjs'
export default {
  name: 'Content',
  components: { Voice, Daily },
  setup (context) {
    const count = ref(0.5)
    // const length = ref()
    const text = ref([])
    const contentRef = ref()
    const swiper = ref()
    const voiceText = ref('')
    const contentWrapper = ref()
    const contentText = ref([])
    const contentList = ref([])
    const contentItem = ref()
    const typeName = ref()
    const newspaper = ref()
    const swiperIndex = ref()
    const changeIndex = ref()
    const newsId = ref()
    const pageId = ref()
    const newspaperId = ref('')
    const pageInfo = ref({})
    const pageNewsArea = ref([])
    const attachedPictures = ref([])
    const content = ref()
    const outfilePath = ref()
    const showHeight = ref()
    const periodical = ref()
    const areaIndex = ref()
    const title = ref()
    const emitDirectoryList = ref([])
    const contentDirectoryList = ref([])
    const attachedList = ref()
    const contentTitleList = ref([])
    const videoElement = ref([])
    // const contentPicList = ref([])
    const Base64 = require('js-base64').Base64
    const imgUrl = process.env.VUE_APP_UPLOAD_URL
    const route = useRoute()
    const router = useRouter()
    const store = useStore()
    newspaper.value = route.params.accessName
    newsId.value = route.params.newsid
    pageId.value = route.params.pageId
    // debugger
    // const PageDate = computed(() => store.state.pageDate)
    store.dispatch('getNewspaper', newspaper.value)
    // const directoryList = computed(() => store.state.directoryList)
    const directoryList = ref([])
    const contentIndex = computed(() => store.state.contentIndex)
    const contentTitle = computed(() => store.state.contentTitle)
    const getDirectoryList = async () => {
      const url = `/tableNewsController/getTableNewsList?ids=${pageId.value}&accessName=${newspaper.value}`
      const result = await get(url)
      directoryList.value = result.list
    }
    getDirectoryList()
    const isDirectoryList = () => {
      if (directoryList.value !== undefined) {
        contentDirectoryList.value = directoryList.value
      }
      contentDirectoryList.value.map((item, index) => {
        const contentItem = {
          contentIndex: index,
          title: item.title
        }
        contentTitleList.value.push(contentItem)
        if (item.id === newsId.value) {
          areaIndex.value = index
          title.value = item.title
          store.dispatch('getContentTitle', title.value)
          store.dispatch('getActiveIndex', index)
        }
        getContentText(item.id, item.accessName)
      })
    }
    watch(
      () => directoryList.value,
      () => {
        isDirectoryList()
      })
    onMounted(() => {
      window.fullHeight = document.documentElement.clientHeight
      showHeight.value = window.fullHeight - 54 + 'px'
    })
    onBeforeUpdate(() => {
      swiper.value.swipeTo(areaIndex.value)
      document.title = title.value
      const contentRef = document.querySelector('#contentRef')
      var hammer = new Hammer(contentRef)
      hammer.get('pinch').set({ enable: true })
      hammer.on('pinchin', e => {
        const currentDom = document.querySelector('#' + newsId.value)
        if (count.value > 0.47) {
          count.value -= 0.05
          currentDom.style.fontSize = count.value + 'rem'
        }
      })
      hammer.on('pinchout', e => {
        const add = document.querySelector('#' + newsId.value)
        // alert(add)
        if (count.value < 0.57) {
          count.value += 0.05
          add.style.fontSize = count.value + 'rem'
        }
      })
    })
    const getContentText = async (id, accessName) => {
      const url = `/tableNewsController/getTableNews?id=${id}&accessName=${accessName}`
      // const url = '/tableNewsController/getTableNews?id=FDF33E50D4D549C9B05F636C06690E3C&accessName=xlglrb'
      const result = await get(url)
      contentText.value = result.data
      const itemId = contentText.value.id
      const title = contentText.value.title
      const orderNumber = contentText.value.orderNumber
      const primersTitle = contentText.value.primersTitle
      const subtitle = contentText.value.subtitle
      const pageDate = contentText.value.pageDate
      const pageNum = contentText.value.pageNum
      const pageName = contentText.value.pageName
      outfilePath.value = contentText.value.pageName.outfilePath
      const author = contentText.value.author
      content.value = Base64.decode(contentText.value.content)
      voiceText.value = (title + primersTitle + subtitle + content.value).replace(/<[^>]+>/g, '')
      typeName.value = contentText.value.typeName
      attachedPictures.value = []
      result.data.attachedPictures.map((item, index) => {
        const picExplain = Base64.decode(item.picExplain)
        attachedList.value = {
          accessName: item.accessName,
          outfilePath: item.outfilePath,
          standardFile: item.standardFile,
          picExplain: picExplain
        }
        attachedPictures.value.push(attachedList.value)
      })
      contentItem.value = {
        orderNumber: orderNumber,
        id: itemId,
        title: title,
        pageDate: pageDate,
        pageNum: pageNum,
        pageName: pageName,
        author: author,
        primersTitle: primersTitle,
        subtitle: subtitle,
        content: content.value,
        voiceText: voiceText.value,
        typeName: typeName.value,
        attachedPictures: attachedPictures.value
      }
      contentList.value.push(contentItem.value)
      contentList.value.sort(compare('orderNumber'))
    }
    const getNewspaper = async () => {
      const url = `/newspaperController/getNewspaper?name=${newspaper.value}`
      const result = await get(url)
      periodical.value = result.data.periodical
      newspaperId.value = result.data.id
      store.dispatch('getPeriodical', periodical.value)
    }
    getNewspaper()
    const getContentDirectory = (data) => {
      emitDirectoryList.value = data
    }
    const getDailyPageList = (data) => {
      swiperIndex.value = data.index
      pageInfo.value = data
      pageNewsArea.value = JSON.parse(pageInfo.value.newsArea)
      store.dispatch('getSwiperIndex', swiperIndex)
    }
    const onChange = (swiperIndex) => {
      for (let i = 0; i < videoElement.value.length; i++) {
        if (changeIndex.value > swiperIndex && i === changeIndex.value) {
          videoElement.value[i].pause()
          store.dispatch('getVoiceState', true)
        }
        if (changeIndex.value < swiperIndex && i === changeIndex.value) {
          videoElement.value[i].pause()
          store.dispatch('getVoiceState', true)
        }
      }
      changeIndex.value = swiperIndex
      contentTitleList.value.map((item, index) => {
        if (swiperIndex === index) {
          document.title = item.title
        }
      })
    }
    const backTop = (e) => {
      e.target.offsetParent.nextElementSibling.lastChild.scrollTo(0, 0)
    }
    // 排序方法
    const compare = (key) => {
      return (a, b) => {
        var val1 = a[key]
        var val2 = b[key]
        return val1 - val2
      }
    }
    watch(
      () => contentIndex.value,
      () => {
        swiper.value.swipeTo(contentIndex.value)
        document.title = contentTitle.value
        // debugger
      }
    )
    watch(contentList.value, () => {
      swiper.value.swipeTo(areaIndex.value)
      if (contentList.value.length > areaIndex.value) {
        document.title = contentList.value[areaIndex.value].title
      }
      videoElement.value = document.getElementsByTagName('audio')
    })
    watch(
      () => contentTitle.value,
      () => {
      // swiper.value.swipeTo(areaIndex.value)
        document.title = contentTitle.value
        // debugger
      })
    // watch(
    //   () => directoryList.value,
    //   () => {
    //     // debugger
    //     contentList.value = []
    //     if (directoryList.value !== undefined) {
    //       // debugger
    //       contentDirectoryList.value = directoryList.value
    //     }
    //     console.log(emitDirectoryList.value)
    //     contentTitleList.value = []
    //     contentDirectoryList.value.map((item, index) => {
    //       // const text = ref('')
    //       const contentItem = {
    //         contentIndex: index,
    //         title: item.title
    //       }
    //       contentTitleList.value.push(contentItem)
    //       debugger
    //       document.title = item.title
    //       newsId.value = route.params.newsid
    //       console.log(newsId.value)
    //       // debugger
    //       if (item.id === newsId.value) {
    //         areaIndex.value = index
    //         title.value = item.title
    //         // debugger
    //         store.dispatch('getActiveIndex', index)
    //         // debugger
    //       }
    //       getContentText(item.id, item.accessName)
    //     })
    //   }
    // )
    // const handleClickSwiperItem = (e) => {
    //   const contentNode = e.target.offsetParent.nextElementSibling.lastChild.lastChild
    //   const add = 'content__icon__wrapper'
    //   document.addEventListener('click', (e) => {
    //     if (add && add.indexOf(e.target)) {
    //       debugger
    //       contentNode.style.fontSize = 22 + 'px'
    //     }
    //   })
    //   // debugger
    // }
    const changeFontSizeAdd = (e) => {
      const contentNode = e.target.offsetParent.nextElementSibling.lastChild.lastChild
      if (count.value < 0.57) {
        count.value += 0.05
        contentNode.style.fontSize = count.value + 'rem'
      }
    }
    const changeFontSizeSubtract = (e) => {
      const contentNode = e.target.offsetParent.nextElementSibling.lastChild.lastChild
      if (count.value > 0.47) {
        count.value -= 0.05
        contentNode.style.fontSize = count.value + 'rem'
      }
    }
    const routeBack = () => {
      router.back()
    }
    const changePrev = () => {
      swiper.value.prev()
      for (let i = 0; i < videoElement.value.length; i++) {
        if (i > 0 && i === changeIndex.value) {
          // debugger
          videoElement.value[i].pause()
          store.dispatch('getVoiceState', true)
        }
      }
    }
    const changeNext = () => {
      swiper.value.next()
      for (let i = 0; i < videoElement.value.length; i++) {
        if (i > 0 && i === changeIndex.value) {
          // debugger
          videoElement.value[i].pause()
          store.dispatch('getVoiceState', true)
        }
      }
    }
    return {
      contentText,
      content,
      voiceText,
      typeName,
      contentList,
      attachedPictures,
      text,
      swiper,
      imgUrl,
      periodical,
      newspaperId,
      newspaper,
      swiperIndex,
      showHeight,
      contentWrapper,
      contentRef,
      routeBack,
      changePrev,
      changeNext,
      changeFontSizeAdd,
      changeFontSizeSubtract,
      getDailyPageList,
      onChange,
      getContentDirectory,
      backTop

    }
  }
}
</script>

<style lang="scss" scoped>

/* Vue 3 深度选择器写法 */
.left-align-text :deep(*) {
  text-align: left !important;
}

.content{
  position: relative;
  width: 100%;
  .content__text{
    font-size: .5rem;
    height: 100%;
    text-align: justify;
    overflow-y: auto;
    padding: .4rem .4rem;
    box-sizing: border-box;
    line-height: .8rem;
    &__h3{
      margin: 0;
      text-align: center;
    }
    &__h4{
      margin: 0;
      text-align: center;
    }
    &__p{
      color: #777777;
      font-size: 16px;
      border-bottom: 1px solid #dddddd;
      span{
        margin-right: 6px;
      }
    }
    &__author{
      color: #777777;
      font-size: 16px;
      text-align: center;
    }
    &__img{
      width: 90%;
      margin: 0 auto;
      text-align: center;
      img{
        width: 100%;
        margin-bottom: 10px;
      }
      p{
        font-size: 14px;
      }
    }
    &__content >>> p{
      margin: 0;
    }
  }
  &__item{
    height: 100%;
    overflow-y: auto;
  }
  &__icon{
    position: absolute;
    bottom: 1rem;
    left: 1rem;
    &__wrapper{
      display: inline-block;
      width: 45px;
      height: 45px;
      line-height: 43px;
      border-radius: 50%;
      background-color: #DE1B23;
      text-align: center;
      opacity: 0.5;
      vertical-align: middle;
      &__item{
        color: #ffffff;
        font-size: 0.6rem;
      }
    }
   .left{
     margin-right: 0.5rem;
   }
  }
  &__left{
    width: 1.5rem;
    height: 1.5rem;
    top: 50%;
    left: 0.3rem;
    position: absolute;
    background-image: url('../../../public/img/next.png');
    background-size: 100% 100%;
    transform: rotate(180deg);
    opacity: 0.6;
  }
  &__next{
    width: 1.5rem;
    height: 1.5rem;
    top: 50%;
    right: 0.3rem;
    position: absolute;
    background-image: url('../../../public/img/next.png');
    background-size: 100% 100%;
    opacity: 0.6;
  }

}
</style>
